
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"38.516","height":"22.598","viewBox":"-8.292 7.625 38.516 22.598"}},[_c('path',{attrs:{"fill":"#212225","d":"M10.965 23.942L-4.701 8.275a.63.63 0 00-.891 0l-2.148 2.148a.63.63 0 000 .891l18.26 18.259a.63.63 0 00.891 0L29.67 11.314a.623.623 0 000-.89l-2.148-2.147a.63.63 0 00-.891 0L10.965 23.942z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      